module.exports = __webpack_public_path__ + "static/logo-3172db64217475f86001fcb7c3bb23f6.svg";